import { EventSchemaAdapter, Resources } from "@validereinc/domain";
import { useGetList, useGetOne } from "./adapterUtils";

export const useGetOneEventSchema = useGetOne(
  EventSchemaAdapter.getOne,
  Resources.EVENT_SCHEMA
);

export const useListEventSchemas = useGetList(
  EventSchemaAdapter.getList,
  Resources.EVENT_SCHEMA
);
